import { createReducer } from "@reduxjs/toolkit";
import type { RequestState } from "@redux/state/shared-types";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import {
  submitExternalProviderInvoice,
  resetSubmitExternalProviderInvoice,
  type SubmittedInvoiceData,
} from "./submit-external-provider-invoice";

export interface ExternalProviderInvoiceSubmissionState {
  processing: RequestState;
  submittedInvoiceData: Nullable<SubmittedInvoiceData>;
}

const initialState: ExternalProviderInvoiceSubmissionState = {
  processing: "idle",
  submittedInvoiceData: null,
};

export const submitExternalProviderInvoiceReducer = createReducer<ExternalProviderInvoiceSubmissionState>(initialState, builder => {
  builder
    .addCase(submitExternalProviderInvoice.fulfilled, (state, action) => {
      return {
        ...state,
        processing: "success",
        submittedInvoiceData: action.payload,
      };
    })
    .addCase(submitExternalProviderInvoice.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(submitExternalProviderInvoice.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetSubmitExternalProviderInvoice, () => {
    return initialState;
  });
});
